export default {
  methods: {
    openInNewTab ({ route, external }) {
      window.open(external ? route : this.$router.resolve(route).href, '_blank')
    },
  },
}
